import logger from './logger';
import { ACTION_TYPE } from './mini-events/constants';
import { buildAdditionalInfoPageLoadMessage } from './mini-events/hotels-action';

import type { Device } from '@shared/types/context';
import type { MiniEventTracker as MiniEventTrackerType } from '@shared/types/frontend/mini-event-tracker';
import type { Optional, Stay, StaySerialized } from '@shared/types/utils';

import {
  PAGELOAD_FAILURE,
  PAGELOAD_SUCCESS,
} from '@shared/constants/newrelic-events/event-names';

type PageLoadParams = {
  deviceInfo: Device;
  isLoggedIn: boolean;
  miniEventTracker: MiniEventTrackerType;
  pageName: string;
  stay: Optional<Stay | StaySerialized>;
  trafficSource: string;
};

type PageLoadSuccessParams = PageLoadParams & {
  fromFlightDBookEmail?: boolean;
  isFallbackTranslations?: boolean;
};

export const pageLoadSuccess = ({
  deviceInfo,
  fromFlightDBookEmail = false,
  isFallbackTranslations = false,
  isLoggedIn,
  miniEventTracker,
  pageName,
  stay,
  trafficSource,
}: PageLoadSuccessParams) => {
  logger.event(PAGELOAD_SUCCESS, {
    trafficSource,
    isRobot: `${deviceInfo.isRobot}`,
    fallbackTranslations: `${isFallbackTranslations}`,
    fromFlightDBookEmail: `${fromFlightDBookEmail}`,
  });

  const actionType =
    ACTION_TYPE[`${pageName}_page_load`.toUpperCase()] ?? ACTION_TYPE.PAGE_LOAD;
  miniEventTracker.trackHotelsAction(
    actionType,
    buildAdditionalInfoPageLoadMessage({
      pageName,
      isLoggedIn,
      stay,
      isSuccessful: true,
    }),
  );
};

export const pageLoadFailure = ({
  deviceInfo,
  isLoggedIn,
  miniEventTracker,
  pageName,
  stay,
  trafficSource,
}: PageLoadParams) => {
  logger.event(PAGELOAD_FAILURE, {
    trafficSource,
    isRobot: `${deviceInfo.isRobot}`,
  });

  const actionType =
    ACTION_TYPE[`${pageName}_page_load`.toUpperCase()] ?? ACTION_TYPE.PAGE_LOAD;
  miniEventTracker.trackHotelsAction(
    actionType,
    buildAdditionalInfoPageLoadMessage({
      pageName,
      isLoggedIn,
      stay,
      isSuccessful: false,
    }),
  );
};
